import { v4 as uuidv4 } from 'uuid';

const initialState = {
  activePreset: null,
  presets: [],
  filter: {
    id: `g-${uuidv4()}`,
    rules: [],
  },
  isFetching: false,
  openPresetDialog: false,
  openPresetDeleteDialog: false,
  presetToDelete: null,
};

function rapidSearch(state = initialState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initialState;
    case 'SEARCH_REQUEST':
      return { ...state, isFetching: true };
    case 'SEARCH_REQUEST_SUCCESS':
      return { ...state, isFetching: false };
    case 'SEARCH_REQUEST_ERROR':
      return { ...state, isFetching: false, error: action.error };

    case 'OPEN_PRESET_DIALOG':
      return { ...state, openPresetDialog: true };
    case 'CLOSE_PRESET_DIALOG':
      return { ...state, openPresetDialog: false };

    case 'OPEN_PRESET_DELETE_DIALOG':
      return { ...state, openPresetDeleteDialog: true, presetToDelete: action.id };
    case 'CLOSE_PRESET_DELETE_DIALOG':
      return { ...state, openPresetDeleteDialog: false, presetToDelete: null };

    case 'SET_FILTER':
      return { ...state, filter: action.filter };
    case 'CLEAR_FILTER':
      return { ...state, filter: { id: `g-${uuidv4()}`, rules: [] }, activePreset: null };
    case 'SET_ACTIVE_PRESET':
      return { ...state, activePreset: action.id };
    case 'SET_PRESETS':
      return { ...state, presets: action.presets };
    default:
      return state;
  }
}

export default rapidSearch;
